module.exports = __webpack_public_path__ + "static/media/features-cardapio.7d82aa11.jpg";